import Vue from "vue";
import router from "@/router";
import stores from "@/store";
import {mapMutations} from "vuex";

const mixin = {
    data(){
      return {
          channel : stores.getters.channel,
          channelOption : stores.getters.channelOption,
          scrollBack: null
      }
    },
    beforeRouteEnter(to, from, next){
        if(to.name.toLowerCase().indexOf("list") > -1){
            stores.commit("setKeepAlive", to)
        }
        next()
    },
    computed: {
        getElementWidth() {
            return (width) => {
                return width > 0 ? this.$tool.resetPixel(width) : 0
            }
        }
    },
    mounted() {
        let ele =  document.getElementsByClassName("my-scroll-box")[0]
        if(ele){
            ele.addEventListener("scroll", this.handleScroll)
        }
    },
    destroyed() {
        let ele =  document.getElementsByClassName("my-scroll-box")[0]
        if(ele){
            ele.removeEventListener("scroll", this.handleScroll)
        }
    },
    methods: {
        ...mapMutations("app", ["setLoading", "setLoadingBg"]),
        handleScroll(){
            let scrollTop = document.getElementsByClassName("my-scroll-box")[0].scrollTop
            // let heightTotal = document.body.clientHeight
            if(this.scrollBack){
                this.scrollBack(scrollTop)
            }
        },
        goBack() {
            router.go(-1)
        },
        verifyNumber(){
            let isNumber = (rule, value, callback) => {
                if(value){
                    if (parseFloat(value) != value) {
                        callback(new Error('请输入数字值'));
                    } else {
                        callback();
                    }
                }else {
                    callback()
                }
            }
            return { validator: isNumber}
        },
        verifyInt(){
            let isNumber = (rule, value, callback) => {
                let r = /^\d+$/
                if(value){
                    if (!r.test(value)) {
                        callback(new Error('请输入整数'));
                    } else {
                        callback();
                    }
                }else {
                    callback()
                }
            }
            return { validator: isNumber }
        },
        verifyMinus(trigger= ["blur"]){
            let isNumber = (rule, value, callback) => {
                if(value){
                    if (parseInt(value) < 0) {
                        callback(new Error('不能输入负数'));
                    }
                }
                callback()
            }
            return { validator: isNumber, trigger}
        },
        //判断小数位数
        verifyDecimalCount(num = 2, trigger= ["blur"]){
            let count = (rule, value, callback) =>{
                if(value){
                    // value = parseFloat(value)
                    let countNumArr = value.toString().split('.')
                    let countNum = 0
                    if(countNumArr.length > 1) countNum = countNumArr[1].length
                    if(countNum >= num + 1){
                        callback(new Error(`小数点后最多为${num}位小数`))
                    }
                }
                callback()
            }
            return {validator:count, trigger}
        },
        //判断输入的值是否为大于等于100
        verifyMax(max, trigger= ["blur"]){
            let isHundred = (rule, value, callback) => {
                if(value){
                    if (parseFloat(value) > max) {
                        callback(new Error('不能大于'+max));
                    }
                }
                callback()
            }
            return { validator: isHundred, trigger}

        },
        verifyMin(min, trigger= ["blur"]){
            let isHundred = (rule, value, callback) => {
                if(value){
                    if (parseFloat(value) < min) {
                        callback(new Error('不能小于'+min));
                    }
                }
                callback()
            }
            return { validator: isHundred, trigger}
        },
        verifyEq(number = 0, trigger= ["blur"]){
            let isHundred = (rule, value, callback) => {
                if (parseFloat(value) === number) {
                    callback(new Error(`不能等于${number}`));
                }
                callback()
            }
            return { validator: isHundred, trigger}
        },
        verifyMobile(trigger= ["blur"]){
            let isHundred = (rule, value, callback) => {
                let myreg=/^1\d{2}[\d*]{4}\d{4}$/
                if (value && !myreg.test(value)) {
                    callback(new Error(`请输入正确手机号`));
                }
                callback()
            }
            return { validator: isHundred, trigger}
        },

        addListenerScroll(containerList, callback, ref="main-container"){
            let container = this.$refs[ref]
            const containerRect = container.getBoundingClientRect()
            let activeIndex = 0
            container.addEventListener("scroll", function (e){
                const clientHeight = container.clientHeight;
                const scrollTop = container.scrollTop;
                const scrollHeight = container.scrollHeight;
                if (clientHeight + scrollTop === scrollHeight) {
                    // console.log('竖向滚动条已经滚动到底部')
                    activeIndex = containerList.length - 1
                }else {
                    for (let i = 0; i < containerList.length; i++) {
                        let rect = document.getElementById(containerList[i]).getBoundingClientRect()
                        // console.log(containerList[i], rect.y, rect.height, containerRect.height, containerRect.top, rect.bottom)

                        if(rect.y > 0 && rect.y < containerRect.height || rect.y < 0 && rect.y + rect.height > containerRect.top){
                            activeIndex = i
                            break
                        }
                    }
                }
                callback(activeIndex)
            })
        }
    }
}

Vue.mixin(mixin)